import { usePageableQuery } from "@/core/queries/usePageableQuery";

import { fetchNewsList } from "../service";

export const useNewsListQuery = () => {
  return usePageableQuery(["news"], params =>
    fetchNewsList({
      ...params,
      size: 8,
      sortConfig: [
        {
          sortBy: "publicationDate",
          order: "DESC",
        },
      ],
    }),
  );
};
